





import { Component, Watch, Vue } from 'vue-property-decorator';
import firebase, { firestore } from 'firebase';
import {FirebaseConnection, Config, Authentications} from '../Classes/Infrastractures';
import {DataInitializeUsecase} from '../Classes/Usecases';
import { State, Getter, Mutation, namespace} from 'vuex-class';
import { FunctionsState } from '../stores/functions/types';
import { Functions, Function, Post } from '../Classes/Entities';
import { PostFactory } from '../Classes/Entities/Chat/PostFactory';
import router from '../router';

const FunctionsModule = namespace('functions');
const ThreadRepositoryModule = namespace('threadRepository');


@Component({
  components: {
  },
})
export default class DataInitialize extends Vue {
  @FunctionsModule.State('functions') 
  public functions!: FunctionsState;

  @ThreadRepositoryModule.State('threadRepository') 
  public threadRepository!: FunctionsState;

  @FunctionsModule.Getter('functionMap') 
  public functionMap!: Functions;

  @FunctionsModule.Mutation('getKeys') 
  public getKeys!: any;

  @ThreadRepositoryModule.Mutation('setThreadRepositories') 
  public setThreadRepositories!: any;

  async created() {
    const connection = new FirebaseConnection(firebase);

    const usecase = new DataInitializeUsecase(connection);
    await usecase.getFunctionAll();

    const keys = usecase.functions;
    this.getKeys(keys);
    const repositories = usecase.threadRepositories;
    this.setThreadRepositories(repositories);

    // console.log(usecase.functions);
    console.log(usecase.threadRepositories);

    router.push('/');

    //console.log(keys)

    return true;
  }
}
